<template>
    <v-sheet v-if="sponsorRows.length" class="sponsors-section" tile>
        <v-container fluid class="sponsors-container py-4 py-md-6">
            <div v-for="(row, rowIndex) in sponsorRows" :key="`sponsor-row-${rowIndex}`" class="sponsor-row-wrapper">
                <div
                    class="sponsor-row"
                    :class="{ 'sponsor-row-single': row.length === 1 }"
                >
                    <a
                        v-for="sponsor in row"
                        :key="sponsor.id"
                        :href="sponsor.website || '#'"
                        :target="sponsor.website ? '_blank' : null"
                        :rel="sponsor.website ? 'noopener noreferrer' : null"
                        class="sponsor-link"
                        :class="{ 'sponsor-link-single': row.length === 1 }"
                        @click.prevent="openSponsor(sponsor)"
                    >
                        <span class="sponsor-image-frame" :class="{ 'sponsor-image-frame-single': row.length === 1 }">
                            <img
                                :src="getSponsorImage(sponsor)"
                                :alt="sponsor.title || 'Χορηγός'"
                                class="sponsor-image"
                            >
                        </span>
                    </a>
                </div>
            </div>
        </v-container>
    </v-sheet>
</template>

<script>
    import sponsorService from '@/services/sponsor'

    let sponsorsCache = null
    let sponsorsRequest = null

    export default {
        name: 'SponsorsSection',
        data() {
            return {
                sponsors: []
            }
        },
        computed: {
            sponsorRows() {
                const validSponsors = this.sponsors.filter(sponsor => sponsor && sponsor.imageName)

                if (!validSponsors.length) {
                    return []
                }

                const hasPriority = validSponsors.some(sponsor => sponsor.priority !== null && sponsor.priority !== undefined)

                if (hasPriority) {
                    const groupedByPriority = validSponsors
                        .slice()
                        .sort((a, b) => {
                            const aPriority = a.priority !== null && a.priority !== undefined ? a.priority : Number.MAX_SAFE_INTEGER
                            const bPriority = b.priority !== null && b.priority !== undefined ? b.priority : Number.MAX_SAFE_INTEGER

                            if (aPriority !== bPriority) {
                                return aPriority - bPriority
                            }

                            return (a.id || 0) - (b.id || 0)
                        })
                        .reduce((groups, sponsor) => {
                            const key = sponsor.priority !== null && sponsor.priority !== undefined ? sponsor.priority : 'no-priority'
                            if (!groups[key]) {
                                groups[key] = []
                            }

                            groups[key].push(sponsor)
                            return groups
                        }, {})

                    return Object.values(groupedByPriority)
                }

                const chunkSize = this.$vuetify.breakpoint.mdAndDown ? 4 : 6
                const rows = []

                for (let index = 0; index < validSponsors.length; index += chunkSize) {
                    rows.push(validSponsors.slice(index, index + chunkSize))
                }

                return rows
            }
        },
        created() {
            this.fetchSponsors()
        },
        methods: {
            fetchSponsors() {
                if (Array.isArray(sponsorsCache)) {
                    this.sponsors = sponsorsCache
                    return Promise.resolve()
                }

                if (sponsorsRequest) {
                    return sponsorsRequest
                        .then(() => {
                            this.sponsors = Array.isArray(sponsorsCache) ? sponsorsCache : []
                        })
                        .catch(() => {
                            this.sponsors = []
                        })
                }

                sponsorsRequest = sponsorService.getSponsors(1, 0)
                    .then(resp => {
                        sponsorsCache = resp.data && Array.isArray(resp.data.data) ? resp.data.data : []
                        this.sponsors = sponsorsCache
                    })
                    .catch(() => {
                        sponsorsCache = []
                        this.sponsors = []
                    })
                    .finally(() => {
                        sponsorsRequest = null
                    })

                return sponsorsRequest
            },
            getSponsorImage(sponsor) {
                return `${process.env.VUE_APP_GOOGLE_BUCKET_URL}${sponsor.imageName}`
            },
            openSponsor(sponsor) {
                if (sponsor.website) {
                    window.open(sponsor.website, '_blank')
                }
            }
        }
    }
</script>

<style scoped>
.sponsors-section {
    margin-top: 12px;
    background: #fff;
}

.sponsors-container {
    width: 100%;
}

.sponsor-row-wrapper {
    margin-bottom: 16px;
}

.sponsor-row-wrapper:last-child {
    margin-bottom: 0;
}

.sponsor-row-wrapper + .sponsor-row-wrapper {
    padding-top: 16px;
}

.sponsor-row {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    align-content: center;
    justify-content: center;
    column-gap: 28px;
    row-gap: 16px;
}

.sponsor-row-single {
    min-height: 168px;
}

.sponsor-link {
    display: flex;
    align-items: center;
    justify-content: center;
    flex: 0 0 auto;
    text-align: center;
}

.sponsor-image-frame {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 250px;
    height: 118px;
}

.sponsor-image-frame-single {
    width: 360px;
    height: 162px;
}

.sponsor-image {
    max-width: 100%;
    max-height: 100%;
    width: auto;
    height: auto;
    display: block;
    margin: auto;
    object-fit: contain;
}

@media only screen and (max-width: 960px) {
    .sponsor-row {
        column-gap: 20px;
        row-gap: 12px;
    }

    .sponsor-image-frame {
        width: 205px;
        height: 94px;
    }

    .sponsor-image-frame-single {
        width: 295px;
        height: 132px;
    }
}

@media only screen and (max-width: 600px) {
    .sponsors-section {
        margin-top: 8px;
    }

    .sponsor-row {
        column-gap: 14px;
        row-gap: 10px;
    }

    .sponsor-row-wrapper {
        margin-bottom: 12px;
    }

    .sponsor-row-wrapper + .sponsor-row-wrapper {
        padding-top: 12px;
    }

    .sponsor-image-frame {
        width: 165px;
        height: 74px;
    }

    .sponsor-image-frame-single {
        width: 235px;
        height: 106px;
    }
}
</style>
